// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2K1Hb","title":"ClientReferral_title__293I5","itemText":"ClientReferral_itemText__2yYUm"};